import axios from 'axios'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { IhLogUrl, metricUrl } from '@/api/config'
import store from '@/store/index'

// 上传语音文件
export function uploadFile(params) {
  const url = IhLogUrl + '/relay/voice'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '下发语音到设备', res)
    }
    return Promise.resolve(res.data)
  })
}

// 上传文字
export function uploadText(params) {
  const url = IhLogUrl + '/relay/word'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '下发文字到设备', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询树状设备列表
export function getSelectList(params) {
  const url = metricUrl + '/device/findDeviceList'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询树状设备列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询历史设备广播发送记录
export function getVoiceList(params) {
  const url = IhLogUrl + '/relay/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '查询历史设备广播发送记录', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.content) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.content.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.content) {
            item.content = item.content.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

// 刷新过期语音
export function refreshVoice(params) {
  const url = IhLogUrl + '/relay/voice/refresh'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('语音通讯', '刷新过期语音', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.content) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.content.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.content) {
            item.content = item.content.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}
